/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  UpdateVehicleClientPreferenceRequestDto,
  VehicleClientPreferenceDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * @summary Get vehicle client preference
 */
export const getVehicleClientPreference = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleClientPreferenceDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/client-preference`, method: 'GET', signal
    },
      );
    }
  

export const getGetVehicleClientPreferenceQueryKey = (vehicleId?: string,) => {
    return [`/fleet/vehicle/v1/vehicles/${vehicleId}/client-preference`] as const;
    }

    
export const getGetVehicleClientPreferenceQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleClientPreference>>, TError = ErrorType<unknown>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleClientPreference>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleClientPreferenceQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleClientPreference>>> = ({ signal }) => getVehicleClientPreference(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleClientPreference>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleClientPreferenceQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleClientPreference>>>
export type GetVehicleClientPreferenceQueryError = ErrorType<unknown>


export function useGetVehicleClientPreference<TData = Awaited<ReturnType<typeof getVehicleClientPreference>>, TError = ErrorType<unknown>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleClientPreference>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleClientPreference>>,
          TError,
          Awaited<ReturnType<typeof getVehicleClientPreference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleClientPreference<TData = Awaited<ReturnType<typeof getVehicleClientPreference>>, TError = ErrorType<unknown>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleClientPreference>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleClientPreference>>,
          TError,
          Awaited<ReturnType<typeof getVehicleClientPreference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleClientPreference<TData = Awaited<ReturnType<typeof getVehicleClientPreference>>, TError = ErrorType<unknown>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleClientPreference>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get vehicle client preference
 */

export function useGetVehicleClientPreference<TData = Awaited<ReturnType<typeof getVehicleClientPreference>>, TError = ErrorType<unknown>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleClientPreference>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleClientPreferenceQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update vehicle client preference
 */
export const updateVehicleClientPreference = (
    vehicleId: string,
    updateVehicleClientPreferenceRequestDto: BodyType<UpdateVehicleClientPreferenceRequestDto>,
 ) => {
      
      
      return customInstance<VehicleClientPreferenceDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/client-preference`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateVehicleClientPreferenceRequestDto
    },
      );
    }
  


export const getUpdateVehicleClientPreferenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleClientPreference>>, TError,{vehicleId: string;data: BodyType<UpdateVehicleClientPreferenceRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicleClientPreference>>, TError,{vehicleId: string;data: BodyType<UpdateVehicleClientPreferenceRequestDto>}, TContext> => {

const mutationKey = ['updateVehicleClientPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicleClientPreference>>, {vehicleId: string;data: BodyType<UpdateVehicleClientPreferenceRequestDto>}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  updateVehicleClientPreference(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleClientPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicleClientPreference>>>
    export type UpdateVehicleClientPreferenceMutationBody = BodyType<UpdateVehicleClientPreferenceRequestDto>
    export type UpdateVehicleClientPreferenceMutationError = ErrorType<unknown>

    /**
 * @summary Update vehicle client preference
 */
export const useUpdateVehicleClientPreference = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleClientPreference>>, TError,{vehicleId: string;data: BodyType<UpdateVehicleClientPreferenceRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVehicleClientPreference>>,
        TError,
        {vehicleId: string;data: BodyType<UpdateVehicleClientPreferenceRequestDto>},
        TContext
      > => {

      const mutationOptions = getUpdateVehicleClientPreferenceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    